export enum AppState {
    START,
    COUNTDOWN,
    QUESTION,
    END,
}

export enum ButtonTypes {
    COLOR,
    CLEAN,
    ALARM,
    OUTLINED,
    OUTLINED_WHITE
}

export enum ModalTypes {
    CORRECT,
    WRONG,
}

export enum LogoSizes {
    SMALL,
    MEDIUM,
    LARGE
}

export enum HighscoreStyle {
    DEFAULT,
    TRANSPARENT
}